import React from 'react'
import T from 'prop-types'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

import Tooltip from './Tooltip'
import IconButton from './IconButton'

const temporaryHide = true
export default function LogIcon({
  label,
  handleClick = () => {},
  showLabel,
  disabled = false,
}) {
  const { t } = useTranslation()

  if (temporaryHide) return false

  const Root = showLabel ? Box : Tooltip
  return (
    <Root title={label || t('common.form.logFile')}>
      <div>
        <IconButton
          onClick={handleClick}
          variant="outlined"
          data-testid="savelog-button"
          disabled={disabled}
        >
          <DescriptionOutlinedIcon />
          {showLabel && (
            <Typography variant="body2" color="textPrimary">
              {label || t('common.form.logFile')}
            </Typography>
          )}
        </IconButton>
      </div>
    </Root>
  )
}

LogIcon.propTypes = {
  label: T.string,
  handleClick: T.func,
  showLabel: T.bool,
}
